export default __webpack_public_path__ + "static/media/avatar-individual-female.bd976ac6.jpg";